interface FuseguLogoProps {
  className?: string
}

export function FuseguLogo({ className = "h-6 w-6" }: FuseguLogoProps) {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Background circle */}
      <circle cx="16" cy="16" r="16" fill="#2563eb"/>

      {/* Shield icon */}
      <path d="M16 6L9 9V14C9 18.5 12.5 22.5 16 24C19.5 22.5 23 18.5 23 14V9L16 6Z" fill="white"/>

      {/* Inner shield detail */}
      <path d="M16 8L11 10.5V14C11 17.5 13.5 20.5 16 22C18.5 20.5 21 17.5 21 14V10.5L16 8Z" fill="#2563eb"/>
    </svg>
  )
}
